// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1PB4X","bigColWidth":"Table_bigColWidth__1aO1v","biggerColWidth":"Table_biggerColWidth__dojf0","row":"Table_row__25oxH","col":"Table_col__wk8Rj"};